import { callBackendApi } from "../../../components/service/axios";

export const fetchUserDetail = async () => {
  return await callBackendApi("get", "/bff/me");
};

export const fetchUserRoles = async (appId) => {
  return await callBackendApi("get", `/bff/user-roles?appId=${appId}`);
};
